import { useTranslation } from "@impero-com/common/utils/i18n";
import { Modal } from "@impero-com/ui";

import type { SegregationOfDutiesConflict } from "api/generated/model";
import { Footer } from "components/modals/Footer";
import { WebRoute } from "routes";

import * as theme from "./SegregationOfDutiesConflictsDialog.css";
import { SegregationOfDutiesConflictsTable } from "./SegregationOfDutiesConflictsTable";

interface SegregationOfDutiesConflictsDialogProps {
    open: boolean;
    title: string;
    conflicts: SegregationOfDutiesConflict[];
    onKeepSetting: () => void;
}

export function SegregationOfDutiesConflictsDialog({
    open,
    title,
    conflicts,
    onKeepSetting,
}: SegregationOfDutiesConflictsDialogProps) {
    const { t } = useTranslation();
    const blockingControlCount = new Set(
        conflicts.map((conflict) => conflict.control.id)
    ).size;

    return (
        <Modal
            variant="content"
            open={open}
            title={title}
            onClose={onKeepSetting}
            footer={
                <Footer
                    onClose={onKeepSetting}
                    cancelLabel={t("ControlPolicies_KeepSetting")}
                    onConfirm={() =>
                        window.open(WebRoute.CONTROLS_ALL, "_blank")
                    }
                    confirmLabel={t("ControlPolicies_ViewControls")}
                />
            }
        >
            <div className={theme.body}>
                <p className={theme.conflictsTitle}>
                    {t("ControlPolicies_SegregationOfDuties_Conflicts_Title", {
                        count: blockingControlCount,
                    })}
                </p>
                <p className={theme.paragraph}>
                    {t("ControlPolicies_SegregationOfDuties_Conflicts_Body")}
                </p>
                <div className={theme.tableScroll}>
                    <SegregationOfDutiesConflictsTable conflicts={conflicts} />
                </div>
            </div>
        </Modal>
    );
}
